/**
 * Lollipop Emoji Replacer for Shopify
 * Replaces all 🍭 emojis with a custom SVG image
 */

(function() {
  'use strict';
  
  // Configuration
  const LOLLIPOP_EMOJI = '🍭';
  const REPLACEMENT_IMAGE = 'https://cdn.shopify.com/s/files/1/0789/1419/1593/files/favicon-sugarcube.png?v=1787608921';
  const IMAGE_ALT_TEXT = 'Heart';
  const IMAGE_CLASS = 'heart-icon';
  
  /**
   * Replace lollipop emoji in a text node
   */
  function replaceInTextNode(textNode) {
    const text = textNode.textContent;
    
    if (text.includes(LOLLIPOP_EMOJI)) {
      const parts = text.split(LOLLIPOP_EMOJI);
      const fragment = document.createDocumentFragment();
      
      parts.forEach((part, index) => {
        // Add the text part
        if (part) {
          fragment.appendChild(document.createTextNode(part));
        }
        
        // Add the image (except after the last part)
        if (index < parts.length - 1) {
          const img = document.createElement('img');
          img.src = REPLACEMENT_IMAGE;
          img.alt = IMAGE_ALT_TEXT;
          img.className = IMAGE_CLASS;
          img.style.display = 'inline-block';
          img.style.width = '1em';
          img.style.height = '1em';
          img.style.verticalAlign = 'middle';
          fragment.appendChild(img);
        }
      });
      
      textNode.parentNode.replaceChild(fragment, textNode);
    }
  }
  
  /**
   * Walk through all text nodes in an element
   */
  function walkTextNodes(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      replaceInTextNode(node);
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      // Skip script and style elements
      if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
        // Create array of child nodes to avoid live collection issues
        const children = Array.from(node.childNodes);
        children.forEach(child => walkTextNodes(child));
      }
    }
  }
  
  /**
   * Replace all lollipop emojis on the page
   */
  function replaceAllLollipops() {
    walkTextNodes(document.body);
  }
  
  /**
   * Observe DOM changes and replace new lollipops
   */
  function observeDOMChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
            walkTextNodes(node);
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  /**
   * Initialize the script
   */
  function init() {
    // Replace existing lollipops
    replaceAllLollipops();
    
    // Watch for dynamically added content
    observeDOMChanges();
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();